import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles(
  {
    root: {
      display: 'block',
      marginBottom: Spacings.s44,
    },
    carousel: {
      '& div[class^=container]': {
        gap: Spacings.s16,
      },
    },
    arrow: {
      [BreakPointsMedia.SM]: {
        display: 'none',
      },
      [BreakPointsMedia.XS]: {
        display: 'none',
      },
      [BreakPointsMedia.XXS]: {
        display: 'none',
      },
    },
  },
  {
    name: 'banner-carousel',
  },
);

export default useStyles;
